<div class="drv-no-connection-card">
  <rmx-icon class="drv-icon-plug"
    name="plug-2-line"></rmx-icon>
  <p class="mt-3">{{ 'COMMON.LABEL.NO_EXISTING_CONNECTIONS' | translate }}</p>
</div>